import JSZip from "jszip";
import { FileCode } from "./DefineTypes";
export class FileHelper {
    /** Zipファイル名からファイルNoを取得する */
    /** 例：1_テンプレート.pdf → 1 */
    static extractFileNo(fileName) {
        const match = /^(\d+)_/.exec(fileName);
        return match ? Number(match[1]) : null;
    }
    static async getAllFilesFromZip(zipBlob) {
        if (!zipBlob) {
            throw new Error("ZIP not loaded");
        }
        const zip = await JSZip.loadAsync(zipBlob);
        const result = [];
        for (const fileName of Object.keys(zip.files)) {
            const entry = zip.files[fileName];
            if (entry.dir) {
                continue;
            }
            const blob = await entry.async("blob");
            result.push({
                blob,
                fileName: fileName.replace(/^(\d+_)+/, ""),
                zipFileName: fileName
            });
        }
        return result;
    }
    /** Zipから指定したファイルNoのファイルを取得する */
    static async getFileFromZip(zipBlob, fileNo, fileCode) {
        if (!zipBlob) {
            throw new Error("ZIP not loaded");
        }
        const zip = await JSZip.loadAsync(zipBlob);
        const entryName = Object.keys(zip.files).find(name => {
            return this.extractFileNo(name) === fileNo;
        });
        if (!entryName) {
            return null;
        }
        const entry = zip.file(entryName);
        if (!entry) {
            return null;
        }
        const blob = await entry.async("blob");
        return {
            blob,
            fileName: entryName.replace(fileCode === FileCode.LoginFile ? /^(\d+_)?/ : /^(\d+_)(\d+_)?/, ""),
            zipFileName: entryName
        };
    }
    /** Zipから複数ファイルを取得する */
    static async getFilesFromZip(zipBlob, files) {
        if (!zipBlob) {
            throw new Error("ZIP not loaded");
        }
        const zip = await JSZip.loadAsync(zipBlob);
        const zipFileNames = Object.keys(zip.files);
        return Promise.all(files.map(async (file) => {
            const entryName = zipFileNames.find(name => {
                return this.extractFileNo(name) === file.fileNo;
            });
            if (!entryName) {
                return file;
            }
            const entry = zip.file(entryName);
            if (!entry) {
                return file;
            }
            const blob = await entry.async("blob");
            return {
                ...file,
                blob,
                zipFileName: entryName
            };
        }));
    }
    /** Zip内の最初のファイルを取得する */
    static async getFirstFileFromZip(zipBlob) {
        if (!zipBlob) {
            throw new Error("ZIP not loaded");
        }
        const zip = await JSZip.loadAsync(zipBlob);
        const entryName = Object.keys(zip.files).find(name => !zip.files[name].dir);
        if (!entryName) {
            return null;
        }
        const entry = zip.file(entryName);
        if (!entry) {
            return null;
        }
        const blob = await entry.async("blob");
        return {
            blob,
            fileName: entryName.replace(/^(\d+_)(\d+_)?/, ""),
            zipFileName: entryName
        };
    }
    /** Blobをダウンロードする */
    static downloadBlob(blob, fileName) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    }
    /** BlobからURLを生成する */
    static createObjectUrl(blob) {
        return URL.createObjectURL(blob);
    }
    /** ファイル名からMIMEタイプを取得する */
    static getMimeType(fileName) {
        const extension = fileName
            .split(".")
            .pop()
            ?.toLowerCase();
        switch (extension) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "gif":
                return "image/gif";
            case "txt":
                return "text/plain";
            case "csv":
                return "text/csv";
            default:
                return "application/octet-stream";
        }
    }
    /** ファイルから拡張子を取得する */
    static getExtension(fileName) {
        const pos = fileName.lastIndexOf(".");
        if (pos === -1) {
            return "";
        }
        return fileName.slice(pos + 1);
    }
    /** ファイルの拡張子が許可されているかチェックする */
    static hasAllowedExtension(fileName, allowExtensions) {
        const extension = this.getExtension(fileName).toLowerCase();
        return allowExtensions.some(allowExtension => allowExtension.toLowerCase() === extension);
    }
    /** ファイルが正常に読み込めるかチェックする */
    static async isReadableFile(file) {
        try {
            await file.arrayBuffer();
            return true;
        }
        catch {
            return false;
        }
    }
    /** ファイルがPDFかチェックする */
    static isPDF(fileName) {
        return fileName.toLowerCase().endsWith(".pdf");
    }
}
